import { Grid, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { StandardDialog } from "../../../../../shared/components/dialogs/StandardDialog"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { StandardButton } from "../../../../../shared/components/buttons/StandardButton"

type LockedDialogProps = Readonly<{
    open: boolean
    onClose: () => void
}>

const useStyles = makeStyles()((theme) => ({
    container: {
        paddingBottom: theme.spacing(9),
        marginTop: "-1rem",
    },
}))

export function LockedDialog({ open, onClose }: LockedDialogProps) {
    const { classes } = useStyles()

    return (
        <StandardDialog
            open={open}
            onClose={onClose}
            maxWidthProp="md"
            dialogTitle={
                <LocalizedStrict id="messages-table-update-delete-dialog-title">
                    <>This message can't be updated / deleted</>
                </LocalizedStrict>
            }
        >
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                direction="column"
                wrap="nowrap"
                className={classes.container}
            >
                <Grid container direction="column" wrap="nowrap" alignItems="center" marginTop="2rem" gap="2rem">
                    <LocalizedStrict id="messages-table-update-delete-dialog-description">
                        <Typography variant="body1">
                            Messages can't be updated or deleted because it's published.
                        </Typography>
                    </LocalizedStrict>
                    <LocalizedStrict id="messages-table-update-delete-dialog-button">
                        <StandardButton size="medium" fullWidth={false} color="black" onClick={onClose}>
                            Close
                        </StandardButton>
                    </LocalizedStrict>
                </Grid>
            </Grid>
        </StandardDialog>
    )
}
